export const adjustTimezone = (d: Date): Date => {
  const timeOffsetInMS: number = d.getTimezoneOffset() * 60000;
  d.setTime(d.getTime() + timeOffsetInMS);
  return d as Date;
};
